import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/mercari-w9';

export default function Example() {
  return (
    <>
      <Head>
        <title>Mercari W-9 Requirements for 2022</title>
        <meta
          name='description'
          content='Starting January 1, 2022, Mercari will require sellers with $600 or more gross sales to submit a W-9. The Internal Revenue Services (IRS) and state tax agencies use the W-9 for income reporting purposes.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/mercari-w9' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/mercari-w9' />
        <meta property='og:title' content='Mercari W-9 Requirements for 2022' />
        <meta
          property='og:description'
          content='Starting January 1, 2022, Mercari will require sellers with $600 or more gross sales to submit a W-9. The Internal Revenue Services (IRS) and state tax agencies use the W-9 for income reporting purposes.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='February 22nd, 2022' />
        <meta property='article:modified_time' content='February 22nd, 2022' />
        <meta property='article:tag' content='Mercari' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
